import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthErrorAlert = ({
  reasonKey,
  onClose,
  errorContext
}) => {
  const getText = () => {
    return {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "authError.title"
      }),
      contentText: /*#__PURE__*/_jsx(FormattedHTMLMessage, Object.assign({
        message: `authError.content.${reasonKey}`
      }, errorContext && {
        options: errorContext
      }))
    };
  };
  const {
    titleText,
    contentText
  } = getText();
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "800",
    type: "danger",
    closeable: true,
    onClose: onClose,
    titleText: titleText,
    children: contentText
  });
};
export default AuthErrorAlert;